import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function StickyHeader() {
  const {
    minutes,
    seconds
  } = useCountdown(13, 11);
  return <div className="sticky top-0 z-50 bg-red-600 text-white py-1.5 px-4 shadow-sm text-center font-medium text-xs tracking-wide" data-id="element-167">
      <div className="container mx-auto flex justify-center items-center gap-2" data-id="element-168">
        <span data-id="element-169">
          ⏳ OFERTA EXPIRA EN:{' '}
          <span className="bg-black/20 px-1.5 py-0.5 rounded font-mono text-sm" data-id="element-170">
            {minutes}:{seconds}
          </span>
        </span>
        <span className="hidden md:inline" data-id="element-171">|</span>
        <span className="hidden md:inline" data-id="element-172">🔥 CUPOS LIMITADOS</span>
      </div>
    </div>;
}